module.exports = __webpack_public_path__ + "img/green_104.94c1ff7d.png";